import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import ErrorIcon from '@mui/icons-material/Error';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import {
    Box,
    Grid,
    Paper,
    styled,
    Tab,
    Tabs,
    Typography,
    useMediaQuery,
} from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import General from '../components/Profile/General';
import Network from '../components/Profile/Network';
import TeacherNetworkView from '../components/Profile/TeacherNetworkView';
import SchoolInfo from '../components/Profile/SchoolInfo';
import SimpleMap from '../components/Profile/SimpleMap';
import Skills from '../components/Profile/Skills';
import Subscription from '../components/Profile/Subscription';
import TeacherList from '../components/Profile/TeacherList';
import StaffNeeds from '../components/Profile/StaffNeeds';
import UploadSection from '../components/Profile/UploadSection';
import sendNotification from '../utils/sendNotification';
import { fetchSchool } from '../redux/SchoolSlice';
import CertifySection from '../components/Profile/CertifySection';
import InviteUsers from '../components/Profile/InviteUsers';

const validPermission = 'update:schoolProfile';
const certifiedPermission = 'create:availability';
const networkPermission = 'create:network';

const UserTabPanel = styled(TabPanel)(({ theme }) => ({
    padding: '40px auto',
    margin: 'auto',
    textAlign: 'center',
}));

/**
 * Component for entering in a mobile number.
 *
 * @component Profile
 * @param {object} props props
 * @param {object} props.match
 * @param {object} props.params
 * @param {string} props.params.route
 *
 * @return (
 * <ProfileComponent/>
 * )
 */
export const ProfileComponent = props => {
    let history = useHistory();
    let location = useLocation();
    // const classes = useStyles();

    const { user, getAccessTokenSilently } = useAuth0();

    const dispatch = useDispatch();
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

    /***************
     * States
     ***************/
    // Tab Selector; default '1'

    // profileImg Modal; default closed

    // Redux selector for profile status
    const profileStatus = useSelector(state => state.profile.status);
    const tokenStatus = useSelector(state => state.token.status);
    const { token } = useSelector(state => state.token);

    // Main state
    const [state, setState] = useState({
        apiMessage: '',
        submitError: false,
        email: '',
        ackronym: '',
        schoolAdmin: false,
        networkPermission: false,
        fullVerification: false,
    });

    const [skillsComplete, setSkillsComplete] = useState(false);

    //useEffect is completed on page load
    //Service to get the profile for a user
    useEffect(() => {
        if (profileStatus === 'succeeded' && profile.Data.Count > 0) {
            if (profile.Data.Items[0].type === 'School') {
                if (schoolStatus !== 'succeeded') {
                    async function dispatchSchoolFromStore() {
                        const token = await getAccessTokenSilently({
                            scope: process.env.REACT_APP_scope,
                        });
                        const requestData = {
                            'token': token,
                            'schoolId': profile.Data.Items[0]['gs1-pk'],
                        };
                        await dispatch(fetchSchool(requestData));
                    }
                    dispatchSchoolFromStore();
                }
            } else if (profile.Data.Items[0].type === 'Teacher') {
                //This function is initialse the data if it doesnt exist, else it well set it from the profile state
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAccessTokenSilently, profileStatus, dispatch]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            let schoolAdminTemp = false;
            let certifiedPermissionTemp = false;
            let networkPermissionTemp = false;

            if (token.permissions.includes(validPermission)) {
                schoolAdminTemp = true;
            }
            if (token.permissions.includes(networkPermission)) {
                networkPermissionTemp = true;
            }
            if (token.permissions.includes(certifiedPermission)) {
                certifiedPermissionTemp = true;
            }

            setState({
                ...state,
                schoolAdmin: schoolAdminTemp,
                fullVerification: certifiedPermissionTemp,
                networkPermission: networkPermissionTemp,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    /**************************
     * Functions
     *************************/

    // snackbar alert for profile changes

    function setNotif(severity, autoHideDuration, description) {
        sendNotification(severity, 6000, description);
    }

    const handleTabChange = (event, newPath) => {
        history.push('/profile/' + newPath);
    };

    /*******************
     * Profile selector
     *******************/
    const profile = useSelector(state => state.profile.profile);

    useEffect(() => {
        if (profile.Data.Items === undefined) return;
        const item = profile.Data.Items[0];
        if (
            item.skills === undefined ||
            item.skills.length === 0 ||
            item.grades === undefined ||
            item.grades.length === 0
        ) {
            setSkillsComplete(false);
        } else {
            setSkillsComplete(true);
        }
    }, [profile]);

    /*******************
     * School selector
     *******************/
    const school = useSelector(state => state.school);
    const schoolStatus = useSelector(state => state.school.status);

    /***************
     * Set user type
     ***************/

    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));
    const pathnameSegments = location.pathname.split('/');

    // Check if the pathname has more than two segments
    const hasMoreThanOneSegments = pathnameSegments.filter(
        item => item !== ''
    ).length;

    return (
        <Grid className="full">
            {profile.Data.Count > 0 && (
                <form noValidate autoComplete="off">
                    <Title title={profile.Data.Items[0].type + ' Account'} />
                    <Grid
                        container
                        xs={12}
                        directon="row"
                        justifyContent="space-evenly"
                        alignItems="top"
                        sx={{
                            marginTop:
                                !isTabletAndAbove && hasMoreThanOneSegments > 1
                                    ? 10
                                    : '',
                        }}
                    >
                        {isTabletAndAbove ? (
                            <Grid item xs={10} sx={{ margin: '8px' }}>
                                <Paper>
                                    <Box justify="center" alignItems="center">
                                        {profile.Data.Items[0].type ===
                                            'School' && (
                                            <>
                                                <TabContext
                                                    value={
                                                        props.match.params.route
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            borderBottom: 1,
                                                            borderColor:
                                                                'divider',
                                                        }}
                                                    >
                                                        <Tabs
                                                            aria-label="scrollable force tabs example"
                                                            data-cy="profile-tabs"
                                                            indicatorColor="primary"
                                                            onChange={
                                                                handleTabChange
                                                            }
                                                            scrollButtons
                                                            textColor="primary"
                                                            value={
                                                                props.match
                                                                    .params
                                                                    .route
                                                            }
                                                            variant="scrollable"
                                                            allowScrollButtonsMobile
                                                        >
                                                            <Tab
                                                                label="User Information"
                                                                value="userInfo"
                                                            />
                                                            <Tab
                                                                label="School Information"
                                                                value="schoolInfo"
                                                            />
                                                            {state.schoolAdmin && (
                                                                <Tab
                                                                    label="School Teachers"
                                                                    value="teacherList"
                                                                />
                                                            )}
                                                            {state.schoolAdmin && (
                                                                <Tab
                                                                    label="Staffing Needs"
                                                                    value="staffNeeds"
                                                                />
                                                            )}

                                                            <Tab
                                                                label="School Network"
                                                                value="network"
                                                            />
                                                            {state.schoolAdmin ===
                                                                true && (
                                                                <Tab
                                                                    label="Billing Information"
                                                                    value="billing"
                                                                />
                                                            )}

                                                            {state.schoolAdmin ===
                                                                true && (
                                                                <Tab
                                                                    label="Invitations"
                                                                    value="invitations"
                                                                />
                                                            )}
                                                        </Tabs>
                                                        <UserTabPanel value="userInfo">
                                                            <General
                                                                profile={
                                                                    profile.Data
                                                                        .Items[0]
                                                                }
                                                                profileImage={
                                                                    user.picture
                                                                }
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                        <UserTabPanel value="schoolInfo">
                                                            {schoolStatus !==
                                                            'succeeded' ? (
                                                                <Loading />
                                                            ) : (
                                                                <SchoolInfo
                                                                    school={
                                                                        school
                                                                    }
                                                                    setNotif={
                                                                        setNotif
                                                                    }
                                                                    schoolStatus={
                                                                        schoolStatus
                                                                    }
                                                                    schoolAdmin={
                                                                        state.schoolAdmin
                                                                    }
                                                                />
                                                            )}
                                                        </UserTabPanel>
                                                        <UserTabPanel value="teacherList">
                                                            {schoolStatus !==
                                                            'succeeded' ? (
                                                                <Loading />
                                                            ) : (
                                                                <TeacherList
                                                                    school={
                                                                        school
                                                                    }
                                                                    setNotif={
                                                                        setNotif
                                                                    }
                                                                />
                                                            )}
                                                        </UserTabPanel>
                                                        <UserTabPanel value="staffNeeds">
                                                            {schoolStatus !==
                                                            'succeeded' ? (
                                                                <Loading />
                                                            ) : (
                                                                <StaffNeeds
                                                                    school={
                                                                        school
                                                                    }
                                                                    setNotif={
                                                                        setNotif
                                                                    }
                                                                />
                                                            )}
                                                        </UserTabPanel>

                                                        <UserTabPanel value="billing">
                                                            {schoolStatus !==
                                                            'succeeded' ? (
                                                                <Box>
                                                                    <Loading />
                                                                </Box>
                                                            ) : (
                                                                <Box
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    <Elements
                                                                        stripe={
                                                                            stripePromise
                                                                        }
                                                                    >
                                                                        <Subscription
                                                                            school={
                                                                                school
                                                                            }
                                                                            schoolAdmin={
                                                                                state.schoolAdmin
                                                                            }
                                                                        ></Subscription>
                                                                    </Elements>
                                                                </Box>
                                                            )}
                                                        </UserTabPanel>
                                                        <UserTabPanel value="network">
                                                            <Network
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                                networkPermission={
                                                                    state.networkPermission
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                        {state.schoolAdmin ===
                                                            true && (
                                                            <UserTabPanel value="invitations">
                                                                <InviteUsers
                                                                    schoolUser={
                                                                        true
                                                                    }
                                                                    setNotif={
                                                                        setNotif
                                                                    }
                                                                />
                                                            </UserTabPanel>
                                                        )}
                                                    </Box>
                                                </TabContext>
                                            </>
                                        )}

                                        {profile.Data.Items[0].type ===
                                            'Teacher' && (
                                            <>
                                                <TabContext
                                                    value={
                                                        props.match.params.route
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            borderBottom: 1,
                                                            borderColor:
                                                                'divider',
                                                        }}
                                                    >
                                                        <Tabs
                                                            aria-label="scrollable force tabs example"
                                                            indicatorColor="primary"
                                                            onChange={
                                                                handleTabChange
                                                            }
                                                            scrollButtons
                                                            textColor="primary"
                                                            value={
                                                                props.match
                                                                    .params
                                                                    .route
                                                            }
                                                            variant="scrollable"
                                                            allowScrollButtonsMobile
                                                        >
                                                            <Tab
                                                                label="User Information"
                                                                value="userInfo"
                                                            />
                                                            <Tab
                                                                label="Skills Information"
                                                                value="skills"
                                                            />
                                                            <Tab
                                                                label="Network"
                                                                value="network"
                                                            />
                                                            {state.fullVerification ? (
                                                                <Tab
                                                                    label="Documents"
                                                                    value="documents"
                                                                />
                                                            ) : (
                                                                <Tab
                                                                    icon={
                                                                        <ErrorIcon />
                                                                    }
                                                                    label="Documents"
                                                                    value="documents"
                                                                    iconPosition="end"
                                                                />
                                                            )}

                                                            <Tab
                                                                label="Invitations"
                                                                value="invitations"
                                                            />
                                                            {/* <Tab
                                                          label="Notifications"
                                                          value="notifications"
                                                      /> */}
                                                            {/* <Tab
                                                  label="Security"
                                                  value="security"
                                              />
                                              <Tab
                                                  label="Billing Information"
                                                  value="billing"
                                              /> */}
                                                        </Tabs>

                                                        <UserTabPanel value="userInfo">
                                                            <General
                                                                profile={
                                                                    profile.Data
                                                                        .Items[0]
                                                                }
                                                                profileImage={
                                                                    user.picture
                                                                }
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                        <UserTabPanel value="skills">
                                                            <Skills
                                                                grades={
                                                                    profile.Data
                                                                        .Items[0]
                                                                        .grades
                                                                }
                                                                skills={
                                                                    profile.Data
                                                                        .Items[0]
                                                                        .skills
                                                                }
                                                                otherSkills={
                                                                    profile.Data
                                                                        .Items[0]
                                                                        .otherSkills
                                                                }
                                                                verified={
                                                                    profile.Data
                                                                        .Items[0]
                                                                        .verified
                                                                }
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                        <UserTabPanel value="documents">
                                                            <>
                                                                <CertifySection
                                                                    verified={
                                                                        profile
                                                                            .Data
                                                                            .Items[0]
                                                                            .verified
                                                                    }
                                                                    skillsComplete={
                                                                        skillsComplete
                                                                    }
                                                                    fullVerification={
                                                                        state.fullVerification
                                                                    }
                                                                />
                                                                {skillsComplete &&
                                                                    state.fullVerification && (
                                                                        <UploadSection
                                                                            setNotif={
                                                                                setNotif
                                                                            }
                                                                            type="teacher"
                                                                        />
                                                                    )}
                                                            </>
                                                        </UserTabPanel>
                                                        <UserTabPanel value="network">
                                                            <TeacherNetworkView
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                        <UserTabPanel value="invitations">
                                                            <InviteUsers
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        </UserTabPanel>
                                                    </Box>
                                                </TabContext>
                                            </>
                                        )}
                                    </Box>
                                </Paper>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Paper
                                    sx={{
                                        textAlign: 'center',
                                        padding: '20px ',
                                        margin: 'auto',
                                    }}
                                >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        {profile.Data.Items[0].type ===
                                            'School' && (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {state.schoolAdmin === true &&
                                                    location.pathname.includes(
                                                        'invitations'
                                                    ) && (
                                                        <InviteUsers
                                                            schoolUser={true}
                                                            setNotif={setNotif}
                                                        />
                                                    )}
                                                {location.pathname.includes(
                                                    'network'
                                                ) && (
                                                    <Network
                                                        setNotif={setNotif}
                                                        networkPermission={
                                                            state.networkPermission
                                                        }
                                                    />
                                                )}
                                                {location.pathname.includes(
                                                    'billing'
                                                ) && (
                                                    <div>
                                                        {schoolStatus !==
                                                        'succeeded' ? (
                                                            <Box>
                                                                <Loading />
                                                            </Box>
                                                        ) : (
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    justifyContent:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Elements
                                                                    stripe={
                                                                        stripePromise
                                                                    }
                                                                >
                                                                    <Subscription
                                                                        school={
                                                                            school
                                                                        }
                                                                        schoolAdmin={
                                                                            state.schoolAdmin
                                                                        }
                                                                    ></Subscription>
                                                                </Elements>
                                                            </Box>
                                                        )}
                                                    </div>
                                                )}
                                                {location.pathname.includes(
                                                    'userInfo'
                                                ) && (
                                                    <General
                                                        profile={
                                                            profile.Data
                                                                .Items[0]
                                                        }
                                                        profileImage={
                                                            user.picture
                                                        }
                                                        setNotif={setNotif}
                                                    />
                                                )}
                                                {location.pathname.includes(
                                                    'schoolInfo'
                                                ) && (
                                                    <div>
                                                        {schoolStatus !==
                                                        'succeeded' ? (
                                                            <Loading />
                                                        ) : (
                                                            <SchoolInfo
                                                                school={school}
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                                schoolStatus={
                                                                    schoolStatus
                                                                }
                                                                schoolAdmin={
                                                                    state.schoolAdmin
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                                {location.pathname.includes(
                                                    'teacherList'
                                                ) && (
                                                    <div>
                                                        {schoolStatus !==
                                                        'succeeded' ? (
                                                            <Loading />
                                                        ) : (
                                                            <TeacherList
                                                                school={school}
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                                {location.pathname.includes(
                                                    'staffNeeds'
                                                ) && (
                                                    <div>
                                                        {schoolStatus !==
                                                        'succeeded' ? (
                                                            <Loading />
                                                        ) : (
                                                            <StaffNeeds
                                                                school={school}
                                                                setNotif={
                                                                    setNotif
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {profile.Data.Items[0].type ===
                                            'Teacher' && (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {location.pathname.includes(
                                                    'userInfo'
                                                ) && (
                                                    <General
                                                        profile={
                                                            profile.Data
                                                                .Items[0]
                                                        }
                                                        profileImage={
                                                            user.picture
                                                        }
                                                        setNotif={setNotif}
                                                    />
                                                )}
                                                {location.pathname.includes(
                                                    'skills'
                                                ) && (
                                                    <Skills
                                                        grades={
                                                            profile.Data
                                                                .Items[0].grades
                                                        }
                                                        skills={
                                                            profile.Data
                                                                .Items[0].skills
                                                        }
                                                        otherSkills={
                                                            profile.Data
                                                                .Items[0]
                                                                .otherSkills
                                                        }
                                                        verified={
                                                            profile.Data
                                                                .Items[0]
                                                                .verified
                                                        }
                                                        setNotif={setNotif}
                                                    />
                                                )}

                                                {location.pathname.includes(
                                                    'documents'
                                                ) && (
                                                    <div>
                                                        {' '}
                                                        <CertifySection
                                                            verified={
                                                                profile.Data
                                                                    .Items[0]
                                                                    .verified
                                                            }
                                                            skillsComplete={
                                                                skillsComplete
                                                            }
                                                            fullVerification={
                                                                state.fullVerification
                                                            }
                                                        />
                                                        {skillsComplete &&
                                                            state.fullVerification && (
                                                                <UploadSection
                                                                    setNotif={
                                                                        setNotif
                                                                    }
                                                                    type="teacher"
                                                                />
                                                            )}
                                                    </div>
                                                )}

                                                {location.pathname.includes(
                                                    'network'
                                                ) && (
                                                    <TeacherNetworkView
                                                        setNotif={setNotif}
                                                    />
                                                )}

                                                {location.pathname.includes(
                                                    'invitations'
                                                ) && (
                                                    <InviteUsers
                                                        setNotif={setNotif}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </Box>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>

                    <Grid
                        container
                        xs={12}
                        directon="row"
                        justifyContent="center"
                        alignItems="top"
                        className="hero"
                    >
                        <Grid item xs={10}>
                            <Box
                                className="padding"
                                justify="center"
                                sx={{ margin: '12px 0px' }}
                            >
                                {profile.Data.Items[0].type === 'School' && (
                                    <div>
                                        <Typography variant="h2">
                                            School Address
                                        </Typography>
                                        <Typography variant="body1">
                                            A view of your School's Address
                                        </Typography>
                                        {schoolStatus === 'succeeded' && (
                                            <SimpleMap
                                                center={{
                                                    lat: parseFloat(
                                                        school.school.Data.lat
                                                    ),
                                                    lng: parseFloat(
                                                        school.school.Data.lng
                                                    ),
                                                }}
                                                address={
                                                    school.school.Data.address
                                                }
                                                zoom={14}
                                            />
                                        )}
                                    </div>
                                )}
                                {profile.Data.Items[0].type === 'Teacher' && (
                                    <div>
                                        <Typography variant="h2">
                                            Your Location
                                        </Typography>
                                        <Typography variant="body1">
                                            A view of your Address
                                        </Typography>
                                        <SimpleMap
                                            center={{
                                                lat: parseFloat(
                                                    profile.Data.Items[0].lat
                                                ),
                                                lng: parseFloat(
                                                    profile.Data.Items[0].lng
                                                ),
                                            }}
                                            address={
                                                profile.Data.Items[0].address
                                            }
                                            zoom={14}
                                        />
                                    </div>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Grid>
    );
};

export default withAuthenticationRequired(ProfileComponent, {
    onRedirecting: () => <Loading />,
});
